document.addEventListener('DOMContentLoaded', function () {
  const dropdownMenu = document.querySelector('.dropdown_menu');
  const hamburgerIcon = document.querySelector('.navbar_hamburger');
  const desktopDropdownMenuFreeResources = document.querySelector('.dropdown_menu_desktop_free_resources');
  const FreeResources = document.querySelector('.navbar_free_resources');
  const AllPrograms = document.querySelector('.navbar_all_programs');
  const desktopDropdownMenuAllPrograms = document.querySelector('.dropdown_menu_desktop_all_programs');

  hamburgerIcon.addEventListener('click', function () {
    dropdownMenu.classList.toggle('active');
  });
  FreeResources.addEventListener('click', function () {
    desktopDropdownMenuFreeResources.classList.toggle('active');
    desktopDropdownMenuAllPrograms.classList.remove('active');
  });
  AllPrograms.addEventListener('click', function () {
    desktopDropdownMenuAllPrograms.classList.toggle('active');
    desktopDropdownMenuFreeResources.classList.remove('active');
  });
});
